export const DOCUMENT_TYPE = {
  DOC: 'Policy document',
  BOOKLET: 'Policy booklet',
  RENEWAL_INVITE: 'Renewal invite',
  RENEWED: 'Renewal document',
  ADJUSTED_SCHEDULE: 'Adjusted policy document'
} as const;

export type DocumentType = (typeof DOCUMENT_TYPE)[keyof typeof DOCUMENT_TYPE];
